export default __webpack_public_path__ + "35c5a677d7f6e90b111bd542720378b8.png";